// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2H4-H","inner":"Footer_inner__1liB5"};